import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";

export default function PrivacyPolicy() {
  // ✅ Only AOS init here — window.scrollTo removed (ScrollToTop in index.js handles it)
  useEffect(() => {
    AOS.init({ duration: 600, once: true });
  }, []);

  return (
    <div className="min-h-screen py-12 px-6" style={{ background: "linear-gradient(135deg, #fff9f9 0%, #fce4ec 100%)" }}>
      <div
        className="max-w-4xl mx-auto rounded-3xl p-8 md:p-12"
        style={{
          background: "rgba(255,255,255,0.85)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          border: "1px solid rgba(212,168,83,0.2)",
          boxShadow: "0 24px 64px rgba(26,26,46,0.1)"
        }}
        data-aos="fade-up"
      >
        {/* ✅ Premium heading */}
        <h1
          className="text-3xl sm:text-4xl font-bold text-center"
          style={{ fontFamily: "'Playfair Display', serif", color: "#1a1a2e" }}
        >
          Privacy Policy
        </h1>

        {/* ✅ Gold divider */}
        <div className="divider-gold w-24 mx-auto mt-4" />

        <p className="mt-8 text-gray-700 leading-relaxed">
          Your privacy is extremely important to us. This Privacy Policy explains how Tanya DIY
          ("we", "our", or "us") handles your information when you visit our website or interact
          with our chatbot or other features.
        </p>

        {[
          {
            num: "1",
            title: "Information We Collect",
            text: "We do not collect or permanently store any personal information, photos, or chat messages. The chatbot may process your questions temporarily to provide accurate responses, but this data is not saved on our servers."
          },
          {
            num: "2",
            title: "Chatbot Interactions",
            text: "When you chat with our AI assistant, your messages are used only to generate replies. Once your session ends, the data is deleted automatically and is not stored or shared in any form."
          },
          {
            num: "3",
            title: "Photos & Uploads",
            text: "If you upload a photo or provide an image for analysis, it is processed in real-time to give instant results. We do not store, share, or reuse any images after the analysis is completed."
          },
          {
            num: "4",
            title: "Cookies & Analytics",
            text: "Our site may use cookies and analytics tools (like Google Analytics or Ezoic) to understand visitor trends and improve the website experience. These do not include your personal chat or image data."
          },
          {
            num: "5",
            title: "Data Security",
            text: "We take strong precautions to ensure that your browsing and chatbot experience remain secure. Since we do not store any personal data, there is no risk of your chat or image being accessed later."
          },
        ].map(({ num, title, text }) => (
          <div key={num} className="mt-8">
            <h2
              className="text-xl font-semibold"
              style={{ fontFamily: "'Playfair Display', serif", color: "#1a1a2e" }}
            >
              {num}. {title}
            </h2>
            <p className="mt-2 text-gray-700 leading-relaxed">{text}</p>
          </div>
        ))}

        {/* Section 6 — has email link */}
        <div className="mt-8">
          <h2
            className="text-xl font-semibold"
            style={{ fontFamily: "'Playfair Display', serif", color: "#1a1a2e" }}
          >
            6. Your Rights
          </h2>
          <p className="mt-2 text-gray-700 leading-relaxed">
            You have full control over what you share in the chatbot. If you have any questions
            about privacy or security, you can contact us at{" "}
            {/* ✅ Fixed — no more markdown syntax */}
            <a
              href="mailto:tanyaskincare123@gmail.com"
              className="font-medium underline hover:opacity-80 transition-opacity"
              style={{ color: "#c2185b" }}
            >
              tanyaskincare123@gmail.com
            </a>
            .
          </p>
        </div>

        {/* Section 7 — Ezoic */}
        <div className="mt-8">
          <h2
            className="text-xl font-semibold"
            style={{ fontFamily: "'Playfair Display', serif", color: "#1a1a2e" }}
          >
            7. Ezoic Services
          </h2>
          <p className="mt-2 text-gray-700 leading-relaxed">
            This website uses Ezoic to provide personalization and analytic services. As such,
            Ezoic's privacy policy is in effect and can be reviewed at the following link:{" "}
            <a
              href="http://g.ezoic.net/privacy/tanyadiy.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium underline hover:opacity-80 transition-opacity"
              style={{ color: "#c2185b" }}
            >
              View Ezoic Privacy Policy
            </a>
            .
          </p>
        </div>

        {/* Effective Date */}
        <p className="mt-8 text-gray-600 text-sm">
          <strong>Effective Date:</strong> October 17, 2025
        </p>

        <hr className="divider-gold mt-8" />

        {/* ✅ React Router Link — no page reload */}
        <div className="mt-8 text-center">
          <Link
            to="/"
            className="btn-premium inline-block px-8 py-3 rounded-xl font-semibold text-sm"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
